import { Link } from 'react-router-dom'

interface FooterProps {
  className?: string;
}

export default function Footer({ className = "" }: FooterProps) {
  return (
    <footer className={`border-t bg-background ${className}`}>
      <div className="container py-8 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <img src="https://imagedelivery.net/meCI2KDHmnUhVs_SxNm-Og/a1d82958-cc6f-4bdc-ce0b-25bdc7b27500/public" alt="Giác Ngộ Logo" className="h-8 w-8" />
              <span className="font-bold">Giác Ngộ</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Khám phá Giác Ngộ qua sơ đồ trực quan
            </p>
          </div>
          <div className="hidden md:block">
            <h3 className="mb-4 text-sm font-semibold">Liên kết</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground transition-colors hover:text-foreground">
                  Trang chủ
                </Link>
              </li>
              <li>
                <Link to="/catalog" className="text-muted-foreground transition-colors hover:text-foreground">
                  Danh mục sơ đồ
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-muted-foreground transition-colors hover:text-foreground">
                  Giới thiệu
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="text-muted-foreground transition-colors hover:text-foreground">
                  Liên hệ
                </Link>
              </li>
            </ul>
          </div>
          <div className="hidden md:block">
            <h3 className="mb-4 text-sm font-semibold">Sơ đồ chính</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground">
                  Phân loại Tâm
                </Link>
              </li>
              <li>
                <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground">
                  Phân loại Tâm sở
                </Link>
              </li>
              <li>
                <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground">
                  Phân loại Sắc pháp
                </Link>
              </li>
            </ul>
          </div>
          <div className="hidden md:block">
            <h3 className="mb-4 text-sm font-semibold">Kết nối</h3>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/thiensu.giacngo" target="_blank" rel="noreferrer" className="text-muted-foreground transition-colors hover:text-foreground">
                <span className="sr-only">Facebook</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" target="_blank" rel="noreferrer" className="text-muted-foreground transition-colors hover:text-foreground">
                <span className="sr-only">Twitter</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
              <a href="#" target="_blank" rel="noreferrer" className="text-muted-foreground transition-colors hover:text-foreground">
                <span className="sr-only">GitHub</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
                  <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"></path>
                  <path d="M9 18c-4.51 2-5-2-7-2"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; 2025 Giác Ngộ. Tất cả các quyền được bảo lưu.</p>
          <p>Đây là 1 website học tập nhằm giúp người dùng học tập và nghiên cứu về Phật giáo dựa trên công nghệ AI, không trực thuộc tổ chức nào.</p>
        </div>
      </div>
    </footer>
  )
} 